

import { defineComponent, onBeforeMount, reactive, toRefs } from 'vue'
import BaseButton from './components/BaseButton.vue'
import { mainStore } from 'partners-widget-core'

export default defineComponent({
  name: 'App',
  components: {
    BaseButton,
  },
  props: {
    productId: {
      type: Number,
      required: true,
    },
    productType: {
      type: String,
      default: 'checkout',
    },
    cartRoute: {
      type: String,
      default: '',
    },
    checkoutRoute: {
      type: String,
      default: '',
    },
    basketButtonTitle: {
      type: String,
      default: 'Добавить в корзину'
    },
    orderButtonTitle: {
      type: String,
      default: 'Оформить'
    },
    withCounter: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const params = reactive({
      linkToCart: props.cartRoute ? props.cartRoute : `/${mainStore.store.env.prefixAppUrl}#/personal/cart`,
      linkToCheckout: props.checkoutRoute ? props.checkoutRoute : `/${mainStore.store.env.prefixAppUrl}#/personal/order/make`
    })

    onBeforeMount(async () => {
      document.documentElement.style.setProperty('--b24-green', mainStore.store.env.brandColor)
      document.documentElement.style.setProperty('--b24-green-dark', mainStore.store.env.brandColor)
      document.documentElement.style.setProperty('--b24-green-light', mainStore.store.env.brandColor)
    })

    return {
      ...toRefs(params)
    }
  }
})

